export default __webpack_public_path__ + "static/medtner-op-39-matinata-e6837c913919e00ff08e200e6829589d.mp3";